import React, {Component} from 'react'
import {Button, Form, Row, Col, Input, Table, Modal, Select, Spin, InputNumber, Switch, Tooltip, Popover, Tag} from 'antd'
import {DeleteOutlined, EditOutlined, QuestionCircleFilled, PlusOutlined} from '@ant-design/icons'
import {getPaginationConfig} from '../../components/pagination'
import FormModal from './components/FormModal'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'

const storage = window.localStorage
const {confirm} = Modal

@inject('reportManagementStore','auditLogsStore','accountStore', 'routerStateModel', 'reportTagStore')
@observer
class reportManagement extends Component {
  formRef = React.createRef()
  tabsManagerRef = React.createRef();
  state = {
    // page: 1, // 当前页
    // size: 10, // 每页显示条数
    // total: null, // 总条数
    // tableData: [],
    modalVisible: false,
    reportId: null,
    reportStatus:null
  }
  handleDelete = record => {
    const {t, reportManagementStore, auditLogsStore} = this.props
    let _this = this

    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        reportManagementStore.deleteReport(record.id).then(() => {
        _this.callTabsManagerMethod(record.id);
        const params = {
        logUrl: "/api/v1/report/del",
        logType: '删除报表:' + record.reportName,
        logOperationType: '删除' 
      }
      
      auditLogsStore.insertAuditLog(params)


          _this.handleSearch()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
  }
  callTabsManagerMethod = (id) => {
    if (this.tabsManagerRef.current) {
      this.tabsManagerRef.current.removeTargetKey(id);
    }
  };

  handleSearch = (pageNumber, pageSize) => {
    const {reportManagementStore ,auditLogsStore} = this.props
    const {page, size} = this.state

    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        ...fieldsValue,
        pageNo: pageNumber ? pageNumber : page,
        pageSize: pageSize ? pageSize : size,
      }

      reportManagementStore.getReportList(params).then(res => {
        if (res?.code === 0) {
          // this.setState({
          //   tableData: res?.data?.list,
          //   page: pageNumber ? pageNumber : page, // 当前页
          //   size: pageSize ? pageSize : size, // 每页显示条数
          //   total: res?.data?.total // 总条数
          // })
          reportManagementStore.onChangeTableData({
            tableData: res?.data?.list,
            page: pageNumber ? pageNumber : page, // 当前页
            size: pageSize ? pageSize : size, // 每页显示条数
            total: res?.data?.total // 总条数
          })
          const params = {
            logUrl: "/api/v1/report/page",
            logType: '报表管理查询',
            logOperationType: '查询' 
          }
          
          auditLogsStore.insertAuditLog(params)
        }
      })
    }).catch()
  }

  handleCreate = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleCancel = target => {
    this.setState({
      [target]: false,
      reportId: null
    })
  }

  handleEdit = (record) => {
    this.setState({
      modalVisible: true,
      reportId: record?.id,
      reportStatus: record?.status
    })
  }

  handleStatusChange = (record, field, checked) => {
    const {reportManagementStore} = this.props
    reportManagementStore.setReportStatus(record.id, checked, field==='status' ? 1 : 2).then(() => {
      if(!record.state){
        this.callTabsManagerMethod(record.id);
      }
      this.handleSearch()
    })
  }

  handleSetStatus = record => {
    const {t, reportManagementStore} = this.props
    const {id, status} = record
    let _this = this

    confirm({
      title: status ? t(`general.lockReport`) : t(`general.unlockReport`),
      icon: <QuestionCircleFilled/>,
      content: status ? t(`general.sureToLock`) : t(`general.sureToUnLock`),
      okText: status ? t(`general.lock`) : t(`general.unlock`),
      cancelText: t(`general.cancel`),
      onOk() {
        reportManagementStore.setReportStatus(id, !status).then(() => {
          if(!record.state){
            _this.callTabsManagerMethod(record.id);
          }
          _this.handleSearch()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
    return false
  }

  getRowClassName = (record, index) => {
    let className
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  onValuesChange = (changedValues, allValues) => {
    // const { accountStore } = this.props
    // const tabsSearchForm = localStorage.getItem('tabsSearchForm') ? JSON.parse(localStorage.getItem('tabsSearchForm')) : []
    // const value = [...tabsSearchForm, {'name':'reportManagement', 'value':allValues}]
    // accountStore.setTabsSearchForm(value)
  }

  componentDidMount() {
    const {reportManagementStore, reportTagStore, accountStore} = this.props
    const { isTabHas } = accountStore;
    // if(!isTabHas) {
      reportManagementStore.getReportRoles()
      reportManagementStore.getReportConditions()
      this.handleSearch(1, 10)
    // }
    reportTagStore.onGetReportTagList({
      'pageNo': 1,
      'pageSize': 9999,
    })
  }

  changeReportSort = (e, id) => {
    const {reportManagementStore} = this.props
    reportManagementStore.saveReportSort(id, e.target.value).then(() => {
      this.handleSearch(1, 10)
      reportManagementStore.onSortChange()
    })
  }

  render() {
    const themeStyle = JSON.parse(storage.getItem('themeStyle'))
    const {location, t, reportManagementStore} = this.props
    const { reportRoleList, isFetching, reportTableData} = reportManagementStore
    const {page, size, total, tableData} = reportTableData
    const { modalVisible, reportId,reportStatus} = this.state
    const pagination = getPaginationConfig(page, size, total, this.handleSearch)
    const TagsList = (tags) => {
      const maxCount = 2; // 最多显示的 Tag 数量
      const remainingCount = tags?.length - maxCount; // 剩余的 Tag 数量

      // 如果 Tag 数量超过 maxCount，则截取前 maxCount 个，剩余的用 Tooltip 显示
      const visibleTags = tags?.slice(0, maxCount);
      const content = tags?.map((tag, index) => (
        <Tag color="blue" key={index}>{tag}</Tag>
      ))
      return (
        <div>
          {/* 显示可见的 Tag */}
          {visibleTags?.map((tag, index) => (
            <Tag color="blue" key={index}>{tag}</Tag>
          ))}

          {/* 如果有多余的 Tag，显示剩余数量，并用 Tooltip 展示所有隐藏的 Tag */}
          {remainingCount > 0 && (
          <Popover content={content}>
              <Tag color="blue">+{remainingCount}</Tag>
          </Popover>
          )}
        </div>
      );
    };

    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical" onValuesChange={this.onValuesChange}>
            {/* <div className="searchFormTitle">
              <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
            </div> */}
            <Row gutter={[10, 0]} style={{marginTop: 10}}>
              <Col span={4}>
                <Form.Item name="reportName" label={t(`reportManagement.reportName`)}>
                  <Input placeholder={t(`general.pleaseEnter`)} allowClear/>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="type" label={t(`reportManagement.reportType`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    <Select.Option key={0} value={'查询语句'}>查询语句</Select.Option>
                    <Select.Option key={1} value={'PowerBI'}>PowerBI</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="roles" label={t(`reportManagement.role`)}>
                  <Select
                    placeholder={t(`general.pleaseSelect`)}
                    allowClear mode="multiple"
                    showArrow
                    maxTagCount="responsive"
                    filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {
                      reportRoleList.length > 0
                        ? reportRoleList.map(item => <Select.Option key={item.id} value={item.id}>{item.name}</Select.Option>)
                        : null
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="status" label={t(`reportManagement.status`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    <Select.Option key={true} value={true}>启用</Select.Option>
                    <Select.Option key={false} value={false}>停用</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4}>
                <Form.Item name="enableChatBi" label={t(`reportManagement.smartQueryStatus`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                    <Select.Option key={true} value={true}>启用</Select.Option>
                    <Select.Option key={false} value={false}>停用</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={4} style={{textAlign: 'right', marginTop: 30}}>
                <Button onClick={() => { this.handleSearch(1, 10) }} className="ant-btn-red">{t(`general.search`)}</Button>
                <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
              </Col>
            </Row>
          </Form>

          <Table className="searchResult" dataSource={tableData} rowKey="id" pagination={pagination} rowClassName={this.getRowClassName}>
            <Table.Column width={120} title={t(`reportManagement.reportName`)} dataIndex="reportName" key="reportName" ellipsis={true}/>
            <Table.Column width={80} title={t(`reportManagement.reportType`)} dataIndex="type" key="type" ellipsis={true}/>
            <Table.Column width={120} title={t(`reportManagement.createUser`)} dataIndex="createUser" key="createUser" ellipsis={true}/>
            <Table.Column width={120} title={t(`reportManagement.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
            <Table.Column width={120} title={t(`reportManagement.reportSort`)} dataIndex="reportSort" key="reportSort" render={(text, record) => {
              return (
                <InputNumber value={record.reportSort} onBlur={(e) => this.changeReportSort(e, record.id)} precision={0} controls={false}/>
              )
            }}/>
            <Table.Column align="center" width={80} fixed="left" title={t(`reportManagement.status`)} dataIndex="status" key="status"
              render={(text, record) => {
                return (
                  <Switch
                    checked={record.status}
                    onChange={(checked) => this.handleStatusChange(record, 'status', checked)}
                    checkedChildren={t(`reportManagement.enabled`)}
                    unCheckedChildren={t(`reportManagement.disabled`)}
                  />
                )
              }}
            />
            <Table.Column align="center" width={80} fixed="left" title={t(`reportManagement.smartQueryStatus`)} dataIndex="enableChatBi" key="enableChatBi"
              render={(text, record) => {
                return record.type==='查询语句' ? (
                  <Switch
                    checked={record.enableChatBi}
                    onChange={(checked) => this.handleStatusChange(record, 'enableChatBi', checked)}
                    checkedChildren={t(`reportManagement.enabled`)}
                    unCheckedChildren={t(`reportManagement.disabled`)}
                  />
                ) : null
              }}
            />
            <Table.Column width={120} title={t(`menu.reportTag`)} dataIndex="datasourceTagNames" key="datasourceTagNames" ellipsis={true} render={(text, record) => {
              return record.type==='查询语句' ? (text && text?.length > 0 ? TagsList(text) : null) : null
            }}/>
            <Table.Column width={80} align="center" title={t(`general.action`)} key="Action" render={(text, record) => {
              return (
                <>
                  <Button type="link" onClick={() => this.handleEdit(record)} icon={<EditOutlined/>} title={t(`general.edit`)}/>
                  {/* <Button
                    type="link"
                    onClick={() => this.handleSetStatus(record)}
                    icon={record.status ? <UnlockOutlined/> : <LockOutlined/>}
                    title={record.status ? t(`reportManagement.enabled`) : t(`reportManagement.disabled`)
                    }
                  /> */}
                  <Button type="link" onClick={() => this.handleDelete(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
                </>
              )
            }}/>
          </Table>
          {/* <TabsManager ref={this.tabsManagerRef} />  */}
          {/* 确保 TabsManager 组件已经正确挂载并且 ref 已经被正确赋值 */}

          {
            modalVisible
              ? <FormModal
                handleCancel={this.handleCancel}
                handleSearch={this.handleSearch}
                modalVisible={modalVisible}
                reportId={reportId}
                reportStatus={reportStatus}
              />
              : null
          }
        </div>
      </Spin>
    )
  }
}

export default withTranslation()(reportManagement)
